module.exports = __webpack_public_path__ + "img/Implementation.38fce1e4.png";